
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prenumerata",
      function () {
        return require("private-next-pages/prenumerata.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prenumerata"])
      });
    }
  